module.exports = __webpack_public_path__ + "img/color_whitegold_a-1939-8@2x.2ec1705.webp";